"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelHeader = void 0;

var react_1 = __importDefault(require("react"));

var styles_1 = require("./styles");

var PanelHeader = function PanelHeader(_a) {
  var children = _a.children,
      header = _a.header,
      theme = _a.theme,
      elementId = _a.elementId;
  return react_1["default"].createElement("div", {
    className: (0, styles_1.wrapperStyle)(theme),
    id: elementId
  }, react_1["default"].createElement("div", {
    className: (0, styles_1.headerStyle)(theme)
  }, header), react_1["default"].createElement("div", {
    className: (0, styles_1.contentStyle)()
  }, children));
};

exports.PanelHeader = PanelHeader;